import AddEditSubrightScreen from "../../screens/AddEditSubrightScreen";
import { connect } from "react-redux";
import {
  editSubright,
  addSubright,
  deleteSubright,
} from "../actions/rightsActions";

const mapStateToProps = (state) => ({
  orgs: state.rights.orgs,
  selectedRightCategory: state.rights.selectedRightCategory,
});

const mapDispatchToProps = (dispatch) => ({
  editSubright: (newSubright, oldSubright, navigateFunction) => {
    dispatch(editSubright(newSubright, oldSubright, navigateFunction));
  },
  addSubright: (newSubright, navigateFunction) => {
    dispatch(addSubright(newSubright, navigateFunction));
  },
  deleteSubright: (subright, navigateFunction) => {
    dispatch(deleteSubright(subright, navigateFunction));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditSubrightScreen);
